import { reactFilter, TextLike } from 'mk/bazaar/common/filters/utils';
import * as React from 'react';

const MD_LINK_RE = /\[(.+?)\]\((https?\:.+?)\)/;

// process markdown format links in the form of [link](http://example.com)
// which will ouput this:
// <a href="http://example.com">link</a>
// this filter is used for EXTERNAL links that open with target="_blank"
export const mdLinkize = (text: TextLike, remove: boolean = false) => reactFilter(text, (s: string): React.ReactChild[] => {
    const ret = [];
    const matcher = new RegExp(MD_LINK_RE, 'g');
    let from = 0;
    while (true) {
        const match = matcher.exec(s);
        if (match) {
            const matchLen = match[0].length;
            const visibleText = match[1];
            const lnk = match[2];

            const to = matcher.lastIndex - matchLen;

            // copy text before this link
            ret.push(s.substring(from, to));

            // insert link
            if (remove) {
                ret.push(visibleText);
            } else {
                ret.push(<a href={lnk} target="_blank">{visibleText}</a>);
            }

            from = matcher.lastIndex;
        } else {
            // copy text after last link
            ret.push(s.substring(from));
            break;
        }
    }
    return ret;
});

export const demdLinkize = (text: TextLike) => mdLinkize(text, true);
